import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from "./components/component/Header";
import RequireQualifica from './components/component/RequireQualifica';
import ScrollToTop from './components/component/ScrollToTop';
import LoginPage from './components/LoginPage';
import HomePage from './components/HomePage';
import PrelievoPage from './components/PrelievoPage';
import RientroPage from './components/RientroPage';
import PosizionamentoPage from './components/PosizionamentoPage';
import CorrezionePage from './components/CorrezionePage';
import ConsultazionePage from './components/ConsultazionePage';
// Logout automatico per inattività DISATTIVATO (richiesta utente).
// Codice del hook lasciato intatto in ./hooks/useInactivityLogout.js: per riattivarlo,
// ripristinare questo import e la chiamata useInactivityLogout() in App().
// import useInactivityLogout from './hooks/useInactivityLogout';
import './index.css';
import './styles/DischargePage.css';
import './styles/pkg.css';

// Portale Magazzino Packaging — accesso ai soli magazzinieri (qualifica 3).
const MAGAZZINIERI = [3];

function App() {
  // Logout automatico per inattività DISATTIVATO (richiesta utente) — riattivare insieme all'import sopra.
  // useInactivityLogout();

  return (
    <div className='root'>
      <Header />
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/home" element={<RequireQualifica allowed={MAGAZZINIERI}><HomePage /></RequireQualifica>} />
          <Route path="/prelievo" element={<RequireQualifica allowed={MAGAZZINIERI}><PrelievoPage /></RequireQualifica>} />
          <Route path="/rientro" element={<RequireQualifica allowed={MAGAZZINIERI}><RientroPage /></RequireQualifica>} />
          <Route path="/posizionamento" element={<RequireQualifica allowed={MAGAZZINIERI}><PosizionamentoPage /></RequireQualifica>} />
          <Route path="/correzione" element={<RequireQualifica allowed={MAGAZZINIERI}><CorrezionePage /></RequireQualifica>} />
          <Route path="/consultazione" element={<RequireQualifica allowed={MAGAZZINIERI}><ConsultazionePage /></RequireQualifica>} />
        </Routes>
      </ScrollToTop>
    </div>
  );
}

export default App;
